import { readItemField } from '../compile/item-field-reader';
import { readLayerListEntryUuid } from '../compile/inventory-raw-readers';
import { SWARM_TEMPLATES, SWARM_TEMPLATE_BY_ID } from '../../shared/swarm-templates';

type Row = Record<string, unknown>;
export interface SwarmSelection { base_creature_item_id: string; layers: Row[] }
const field = (row: Row, key: string): string => String(readItemField(row, key) ?? '');
const identity = (value: string): string => value.trim().toUpperCase();

export function monsterTemplateLayers(rows: readonly Row[], templateId: string): Row[] {
    return rows.filter(row => identity(field(row, 'monster_template_id')) === identity(templateId)
        && Number(readItemField(row, 'monster_template_layer_deleted') ?? 0) === 0);
}

/** Change only the swarm classification; other authored overrides retain their order and quantities. */
export function composeSwarmSelection(itemId: string, currentLayers: readonly Row[], quantity: number): SwarmSelection {
    const swarm = Object.values(SWARM_TEMPLATES).find(entry => entry.monsterQty === quantity);
    if (quantity !== 0 && !swarm) throw new Error('modify-swarm:unknown-size');
    const layers = currentLayers.filter(row => field(row, 'item_layer_type_name') !== 'creature_template'
        || !SWARM_TEMPLATE_BY_ID[identity(readLayerListEntryUuid(readItemField(row, 'item_layer_effect')))])
        .map(row => ({ item_layer_type_name: field(row, 'item_layer_type_name'),
            item_layer_effect: readItemField(row, 'item_layer_effect'), qty: readItemField(row, 'qty') }));
    if (swarm) layers.push({ item_layer_type_name: 'creature_template', item_layer_effect: swarm.id, qty: null });
    return { base_creature_item_id: identity(itemId), layers };
}

function layerSet(rows: readonly Row[]): string[] {
    return [...new Set(rows.map(row => JSON.stringify([field(row, 'item_layer_type_name'),
        field(row, 'item_layer_effect'), Number(readItemField(row, 'qty') ?? 1)])))].sort();
}
export function matchingSwarmTemplate(selection: SwarmSelection, templates: readonly Row[], layers: readonly Row[]): string | null {
    const wanted = JSON.stringify(layerSet(selection.layers));
    for (const row of templates) {
        if (identity(field(row, 'base_creature_item_id')) !== selection.base_creature_item_id
            || Number(readItemField(row, 'monster_template_deleted') ?? 0) !== 0) continue;
        const id = field(row, 'monster_template_id');
        if (JSON.stringify(layerSet(monsterTemplateLayers(layers, id))) === wanted) return id;
    }
    return null;
}
